<form [formGroup]="dispatchForm" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">👉 👉 Are you sure deliver ?</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body">
    <!-- ========== COMPARE TABLES (one per product) ========== -->
    <div formArrayName="items">
      <table
        *ngFor="let group of items.controls; let i = index"
        class="table table-bordered compare-table mb-3"
        [formGroupName]="i"
      >
        <thead>
          <tr>
            <th>COMPARE ITEMS</th>
            <th>CUSTOMER LOAD</th>
            <th>PICKUP LOAD</th>
            <th>DIFFERENCE</th>
          </tr>
        </thead>

        <tbody>
          <!-- PRODUCT row -->
          <tr>
            <td>PRODUCT</td>
            <td>
              <span class="fw-bold">
                {{ group.value.product.name }}
              </span>
            </td>
            <td>
              {{ group.value.product.name }}
            </td>
            <td>
              <p class="font-bold text-primary-900">
                {{ group.value.pickupProduct?.code }}
                {{ group.value.pickupProduct?.name }}
              </p>
            </td>
          </tr>

          <!-- WEIGHT row -->
          <tr>
            <td>WEIGHT</td>
            <td>{{ group.value.requestedWeight }}KG</td>
            <td>
              <input
                type="number"
                class="form-control"
                formControlName="pickupWeight"
                [readonly]="mode === 'view'"
                min="0"
              />
            </td>
            <td
              class="{{
                commonService.diffClass(
                  (group.get('pickupWeight')?.value || 0) -
                    (group.get('requestedWeight')?.value || 0)
                )
              }}"
            >
              {{
                (group.get('pickupWeight')?.value || 0) -
                  (group.get('requestedWeight')?.value || 0)
              }}KG
            </td>
          </tr>

          <!-- QUANTITY row -->
          <tr>
            <td>QUANTITY</td>
            <td>{{ group.value.requestedQty }}BOX</td>
            <td>
              <input
                type="number"
                class="form-control"
                formControlName="pickupQty"
                [readonly]="mode === 'view'"
                min="0"
              />
            </td>
            <td
              class="{{
                commonService.diffClass(
                  (group.get('pickupQty')?.value || 0) -
                    (group.get('requestedQty')?.value || 0)
                )
              }}"
            >
              {{
                (group.get('pickupQty')?.value || 0) -
                  (group.get('requestedQty')?.value || 0)
              }}BOX
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ========== UPLOAD SECTIONS ========== -->
    <div class="row">
      <!-- Loading Photos -->
      <div class="col-md-12 mb-4">
        <div class="upload-title text-subtitle2 font-extrabold mb-3">
          Delivery Images
        </div>

        <input
          #loadingInput
          type="file"
          multiple
          accept="image/*,application/pdf"
          (change)="onFileSelected($event, 'loading')"
          hidden
        />

        <div class="row g-3">
          <div class="col-auto" *ngFor="let file of loadingFiles">
            <div class="upload-thumb">
              <ng-container *ngIf="isImage(file); else loadingPdfIcon">
                <img [src]="file.url" [alt]="file.name" />
              </ng-container>
              <ng-template #loadingPdfIcon>
                <!-- use some generic PDF icon -->
                <div class="pdf-icon">{{ file.name }}</div>
              </ng-template>

              <div class="thumb-actions">
                <a
                  href="javascript:void(0)"
                  *ngIf="mode !== 'view'"
                  (click)="onRemoveFile('loading', file)"
                >
                  <!-- delete icon -->
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.86068 14.583C4.47873 14.583 4.15176 14.447 3.87977 14.175C3.60778 13.903 3.47179 13.5761 3.47179 13.1941V4.16634C3.27503 4.16634 3.1101 4.09979 2.977 3.96669C2.84389 3.83359 2.77734 3.66866 2.77734 3.4719C2.77734 3.27514 2.84389 3.11021 2.977 2.97711C3.1101 2.844 3.27503 2.77745 3.47179 2.77745H6.24957C6.24957 2.58069 6.31612 2.41576 6.44922 2.28266C6.58232 2.14956 6.74725 2.08301 6.94401 2.08301H9.72179C9.91855 2.08301 10.0835 2.14956 10.2166 2.28266C10.3497 2.41576 10.4162 2.58069 10.4162 2.77745H13.194C13.3908 2.77745 13.5557 2.844 13.6888 2.97711C13.8219 3.11021 13.8885 3.27514 13.8885 3.4719C13.8885 3.66866 13.8219 3.83359 13.6888 3.96669C13.5557 4.09979 13.3908 4.16634 13.194 4.16634V13.1941C13.194 13.5761 13.058 13.903 12.786 14.175C12.514 14.447 12.1871 14.583 11.8051 14.583H4.86068ZM6.94401 11.8052C7.14077 11.8052 7.3057 11.7387 7.4388 11.6056C7.5719 11.4725 7.63845 11.3075 7.63845 11.1108V6.24967C7.63845 6.05292 7.5719 5.88798 7.4388 5.75488C7.3057 5.62178 7.14077 5.55523 6.94401 5.55523C6.74725 5.55523 6.58232 5.62178 6.44922 5.75488C6.31612 5.88798 6.24957 6.05292 6.24957 6.24967V11.1108C6.24957 11.3075 6.31612 11.4725 6.44922 11.6056C6.58232 11.7387 6.74725 11.8052 6.94401 11.8052ZM9.72179 11.8052C9.91855 11.8052 10.0835 11.7387 10.2166 11.6056C10.3497 11.4725 10.4162 11.3075 10.4162 11.1108V6.24967C10.4162 6.05292 10.3497 5.88798 10.2166 5.75488C10.0835 5.62178 9.91855 5.55523 9.72179 5.55523C9.52503 5.55523 9.3601 5.62178 9.227 5.75488C9.09389 5.88798 9.02734 6.05292 9.02734 6.24967V11.1108C9.02734 11.3075 9.09389 11.4725 9.227 11.6056C9.3601 11.7387 9.52503 11.8052 9.72179 11.8052Z"
                      fill="#F04438"
                    />
                  </svg>
                </a>
                <a href="javascript:void(0)" (click)="onPreviewFile(file)">
                  <!-- preview icon -->
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.99961 10.667C8.83294 10.667 9.54128 10.3753 10.1246 9.79199C10.7079 9.20866 10.9996 8.50033 10.9996 7.66699C10.9996 6.83366 10.7079 6.12533 10.1246 5.54199C9.54128 4.95866 8.83294 4.66699 7.99961 4.66699C7.16628 4.66699 6.45794 4.95866 5.87461 5.54199C5.29128 6.12533 4.99961 6.83366 4.99961 7.66699C4.99961 8.50033 5.29128 9.20866 5.87461 9.79199C6.45794 10.3753 7.16628 10.667 7.99961 10.667ZM7.99961 9.46699C7.49961 9.46699 7.07461 9.29199 6.72461 8.94199C6.37461 8.59199 6.19961 8.16699 6.19961 7.66699C6.19961 7.16699 6.37461 6.74199 6.72461 6.39199C7.07461 6.04199 7.49961 5.86699 7.99961 5.86699C8.49961 5.86699 8.92461 6.04199 9.27461 6.39199C9.62461 6.74199 9.79961 7.16699 9.79961 7.66699C9.79961 8.16699 9.62461 8.59199 9.27461 8.94199C8.92461 9.29199 8.49961 9.46699 7.99961 9.46699ZM7.99961 12.667C6.51072 12.667 5.15239 12.267 3.92461 11.467C2.69683 10.667 1.72739 9.61144 1.01628 8.30033C0.96072 8.20033 0.919054 8.09755 0.891276 7.99199C0.863498 7.88644 0.849609 7.7781 0.849609 7.66699C0.849609 7.55588 0.863498 7.44755 0.891276 7.34199C0.919054 7.23644 0.96072 7.13366 1.01628 7.03366C1.72739 5.72255 2.69683 4.66699 3.92461 3.86699C5.15239 3.06699 6.51072 2.66699 7.99961 2.66699C9.4885 2.66699 10.8468 3.06699 12.0746 3.86699C13.3024 4.66699 14.2718 5.72255 14.9829 7.03366C15.0385 7.13366 15.0802 7.23644 15.1079 7.34199C15.1357 7.44755 15.1496 7.55588 15.1496 7.66699C15.1496 7.7781 15.1357 7.88644 15.1079 7.99199C15.0802 8.09755 15.0385 8.20033 14.9829 8.30033C14.2718 9.61144 13.3024 10.667 12.0746 11.467C10.8468 12.267 9.4885 12.667 7.99961 12.667Z"
                      fill="#004B64"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Weight Slip -->
      <div class="col-md-12 mb-4">
        <div class="upload-title text-subtitle2 font-extrabold mb-3">
          Delivery photos
        </div>

        <input
          #weightSlipInput
          type="file"
          multiple
          accept="image/*,application/pdf"
          (change)="onFileSelected($event, 'weightSlip')"
          hidden
        />

        <div class="row g-3">
          <div class="col-auto" *ngFor="let file of weightSlipFiles">
            <div class="upload-thumb">
              <ng-container *ngIf="isImage(file); else weightPdfIcon">
                <img [src]="file.url" [alt]="file.name" />
              </ng-container>
              <ng-template #weightPdfIcon>
                <div class="pdf-icon">{{ file.name }}</div>
              </ng-template>

              <div class="thumb-actions">
                <a
                  href="javascript:void(0)"
                  *ngIf="mode !== 'view'"
                  (click)="onRemoveFile('weightSlip', file)"
                >
                  <svg
                    width="17"
                    height="17"
                    viewBox="0 0 17 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.86068 14.583C4.47873 14.583 4.15176 14.447 3.87977 14.175C3.60778 13.903 3.47179 13.5761 3.47179 13.1941V4.16634C3.27503 4.16634 3.1101 4.09979 2.977 3.96669C2.84389 3.83359 2.77734 3.66866 2.77734 3.4719C2.77734 3.27514 2.84389 3.11021 2.977 2.97711C3.1101 2.844 3.27503 2.77745 3.47179 2.77745H6.24957C6.24957 2.58069 6.31612 2.41576 6.44922 2.28266C6.58232 2.14956 6.74725 2.08301 6.94401 2.08301H9.72179C9.91855 2.08301 10.0835 2.14956 10.2166 2.28266C10.3497 2.41576 10.4162 2.58069 10.4162 2.77745H13.194C13.3908 2.77745 13.5557 2.844 13.6888 2.97711C13.8219 3.11021 13.8885 3.27514 13.8885 3.4719C13.8885 3.66866 13.8219 3.83359 13.6888 3.96669C13.5557 4.09979 13.3908 4.16634 13.194 4.16634V13.1941C13.194 13.5761 13.058 13.903 12.786 14.175C12.514 14.447 12.1871 14.583 11.8051 14.583H4.86068ZM6.94401 11.8052C7.14077 11.8052 7.3057 11.7387 7.4388 11.6056C7.5719 11.4725 7.63845 11.3075 7.63845 11.1108V6.24967C7.63845 6.05292 7.5719 5.88798 7.4388 5.75488C7.3057 5.62178 7.14077 5.55523 6.94401 5.55523C6.74725 5.55523 6.58232 5.62178 6.44922 5.75488C6.31612 5.88798 6.24957 6.05292 6.24957 6.24967V11.1108C6.24957 11.3075 6.31612 11.4725 6.44922 11.6056C6.58232 11.7387 6.74725 11.8052 6.94401 11.8052ZM9.72179 11.8052C9.91855 11.8052 10.0835 11.7387 10.2166 11.6056C10.3497 11.4725 10.4162 11.3075 10.4162 11.1108V6.24967C10.4162 6.05292 10.3497 5.88798 10.2166 5.75488C10.0835 5.62178 9.91855 5.55523 9.72179 5.55523C9.52503 5.55523 9.3601 5.62178 9.227 5.75488C9.09389 5.88798 9.02734 6.05292 9.02734 6.24967V11.1108C9.02734 11.3075 9.09389 11.4725 9.227 11.6056C9.3601 11.7387 9.52503 11.8052 9.72179 11.8052Z"
                      fill="#F04438"
                    />
                  </svg>
                </a>
                <a href="javascript:void(0)" (click)="onPreviewFile(file)">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.99961 10.667C8.83294 10.667 9.54128 10.3753 10.1246 9.79199C10.7079 9.20866 10.9996 8.50033 10.9996 7.66699C10.9996 6.83366 10.7079 6.12533 10.1246 5.54199C9.54128 4.95866 8.83294 4.66699 7.99961 4.66699C7.16628 4.66699 6.45794 4.95866 5.87461 5.54199C5.29128 6.12533 4.99961 6.83366 4.99961 7.66699C4.99961 8.50033 5.29128 9.20866 5.87461 9.79199C6.45794 10.3753 7.16628 10.667 7.99961 10.667ZM7.99961 9.46699C7.49961 9.46699 7.07461 9.29199 6.72461 8.94199C6.37461 8.59199 6.19961 8.16699 6.19961 7.66699C6.19961 7.16699 6.37461 6.74199 6.72461 6.39199C7.07461 6.04199 7.49961 5.86699 7.99961 5.86699C8.49961 5.86699 8.92461 6.04199 9.27461 6.39199C9.62461 6.74199 9.79961 7.16699 9.79961 7.66699C9.79961 8.16699 9.62461 8.59199 9.27461 8.94199C8.92461 9.29199 8.49961 9.46699 7.99961 9.46699ZM7.99961 12.667C6.51072 12.667 5.15239 12.267 3.92461 11.467C2.69683 10.667 1.72739 9.61144 1.01628 8.30033C0.96072 8.20033 0.919054 8.09755 0.891276 7.99199C0.863498 7.88644 0.849609 7.7781 0.849609 7.66699C0.849609 7.55588 0.863498 7.44755 0.891276 7.34199C0.919054 7.23644 0.96072 7.13366 1.01628 7.03366C1.72739 5.72255 2.69683 4.66699 3.92461 3.86699C5.15239 3.06699 6.51072 2.66699 7.99961 2.66699C9.4885 2.66699 10.8468 3.06699 12.0746 3.86699C13.3024 4.66699 14.2718 5.72255 14.9829 7.03366C15.0385 7.13366 15.0802 7.23644 15.1079 7.34199C15.1357 7.44755 15.1496 7.55588 15.1496 7.66699C15.1496 7.7781 15.1357 7.88644 15.1079 7.99199C15.0802 8.09755 15.0385 8.20033 14.9829 8.30033C14.2718 9.61144 13.3024 10.667 12.0746 11.467C10.8468 12.267 9.4885 12.667 7.99961 12.667Z"
                      fill="#004B64"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Upload sections end -->
    </div>

    <div class="modal-footer">
      `
      <div class="d-flex align-items-center justify-content-between w-100">
        <button
          class="btn btn-light d-flex align-items-center justify-content-center gap-1"
          type="button"
          (click)="loadingInput.click()"
          [disabled]="mode === 'view'"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.0007 13.1253C15.0007 14.5698 14.4937 15.7989 13.4798 16.8128C12.4659 17.8267 11.2368 18.3337 9.79232 18.3337C8.34787 18.3337 7.11871 17.8267 6.10482 16.8128C5.09093 15.7989 4.58398 14.5698 4.58398 13.1253V5.41699C4.58398 4.37533 4.94857 3.48991 5.67773 2.76074C6.4069 2.03158 7.29232 1.66699 8.33398 1.66699C9.37565 1.66699 10.2611 2.03158 10.9902 2.76074C11.7194 3.48991 12.084 4.37533 12.084 5.41699V12.7087C12.084 13.3475 11.8618 13.8892 11.4173 14.3337C10.9729 14.7781 10.4312 15.0003 9.79232 15.0003C9.15343 15.0003 8.61176 14.7781 8.16732 14.3337C7.72287 13.8892 7.50065 13.3475 7.50065 12.7087V5.83366C7.50065 5.59755 7.58051 5.39963 7.74023 5.23991C7.89996 5.08019 8.09787 5.00033 8.33398 5.00033C8.5701 5.00033 8.76801 5.08019 8.92773 5.23991C9.08746 5.39963 9.16732 5.59755 9.16732 5.83366V12.7087C9.16732 12.8892 9.22635 13.0385 9.3444 13.1566C9.46246 13.2746 9.61176 13.3337 9.79232 13.3337C9.97287 13.3337 10.1222 13.2746 10.2402 13.1566C10.3583 13.0385 10.4173 12.8892 10.4173 12.7087V5.41699C10.4034 4.83366 10.1986 4.3406 9.80273 3.93783C9.4069 3.53505 8.91732 3.33366 8.33398 3.33366C7.75065 3.33366 7.2576 3.53505 6.85482 3.93783C6.45204 4.3406 6.25065 4.83366 6.25065 5.41699V13.1253C6.23676 14.1114 6.57704 14.9482 7.27148 15.6357C7.96593 16.3232 8.80621 16.667 9.79232 16.667C10.7645 16.667 11.5909 16.3232 12.2715 15.6357C12.952 14.9482 13.3062 14.1114 13.334 13.1253V5.83366C13.334 5.59755 13.4138 5.39963 13.5736 5.23991C13.7333 5.08019 13.9312 5.00033 14.1673 5.00033C14.4034 5.00033 14.6013 5.08019 14.7611 5.23991C14.9208 5.39963 15.0007 5.59755 15.0007 5.83366V13.1253Z"
              fill="#004B64"
            />
          </svg>
          Delivery photos
        </button>

        <button
          class="btn btn-light d-flex align-items-center justify-content-center gap-1"
          type="button"
          (click)="weightSlipInput.click()"
          [disabled]="mode === 'view'"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.0007 13.1253C15.0007 14.5698 14.4937 15.7989 13.4798 16.8128C12.4659 17.8267 11.2368 18.3337 9.79232 18.3337C8.34787 18.3337 7.11871 17.8267 6.10482 16.8128C5.09093 15.7989 4.58398 14.5698 4.58398 13.1253V5.41699C4.58398 4.37533 4.94857 3.48991 5.67773 2.76074C6.4069 2.03158 7.29232 1.66699 8.33398 1.66699C9.37565 1.66699 10.2611 2.03158 10.9902 2.76074C11.7194 3.48991 12.084 4.37533 12.084 5.41699V12.7087C12.084 13.3475 11.8618 13.8892 11.4173 14.3337C10.9729 14.7781 10.4312 15.0003 9.79232 15.0003C9.15343 15.0003 8.61176 14.7781 8.16732 14.3337C7.72287 13.8892 7.50065 13.3475 7.50065 12.7087V5.83366C7.50065 5.59755 7.58051 5.39963 7.74023 5.23991C7.89996 5.08019 8.09787 5.00033 8.33398 5.00033C8.5701 5.00033 8.76801 5.08019 8.92773 5.23991C9.08746 5.39963 9.16732 5.59755 9.16732 5.83366V12.7087C9.16732 12.8892 9.22635 13.0385 9.3444 13.1566C9.46246 13.2746 9.61176 13.3337 9.79232 13.3337C9.97287 13.3337 10.1222 13.2746 10.2402 13.1566C10.3583 13.0385 10.4173 12.8892 10.4173 12.7087V5.41699C10.4034 4.83366 10.1986 4.3406 9.80273 3.93783C9.4069 3.53505 8.91732 3.33366 8.33398 3.33366C7.75065 3.33366 7.2576 3.53505 6.85482 3.93783C6.45204 4.3406 6.25065 4.83366 6.25065 5.41699V13.1253C6.23676 14.1114 6.57704 14.9482 7.27148 15.6357C7.96593 16.3232 8.80621 16.667 9.79232 16.667C10.7645 16.667 11.5909 16.3232 12.2715 15.6357C12.952 14.9482 13.3062 14.1114 13.334 13.1253V5.83366C13.334 5.59755 13.4138 5.39963 13.5736 5.23991C13.7333 5.08019 13.9312 5.00033 14.1673 5.00033C14.4034 5.00033 14.6013 5.08019 14.7611 5.23991C14.9208 5.39963 15.0007 5.59755 15.0007 5.83366V13.1253Z"
              fill="#004B64"
            />
          </svg>
          Proof of delivery
        </button>

        <button
          class="btn btn-primary"
          type="submit"
          *ngIf="mode !== 'view'"
          [disabled]="dispatchForm.invalid || isSubmitting"
        >
          {{ mode === 'edit' ? 'Update Deliver' : 'Deliver' }}
        </button>

        <button
          class="btn btn-secondary"
          type="button"
          *ngIf="mode === 'view'"
          (click)="cancel()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</form>
